var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-main"},[_c('audio',{ref:"audio",attrs:{"src":"img/blank.mp3","controls":""},on:{"ended":_vm.next}})])}
var staticRenderFns = []

export { render, staticRenderFns }